import AccountRax from './AccountRax';

export default AccountRax;
